export const NEPALI_REGEX = /^(?=.*[\u0900-\u097F-])(?!.*[a-zA-Z0-9])[\u0900-\u097F(\s)-;,$#@!)(=+?^(\\)(\/)]+$/
